import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CartMini from "./CartMini";

function CenteredModal(props) {


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {props.modalText}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={props.onHide}>{props.buttonText}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CenteredModal